import * as FIELD_NAME from 'constant/form-item-names'
import * as FIELD_LABEL from 'constant/form-labels'
import React from 'react'
import PropTypes from 'prop-types'
import { Select, Form } from 'antd'
import { connect } from 'react-redux'

const { Option } = Select

const AssociatedDataSet = ({ datasets }) => {
  return (
    <>
      <span>{FIELD_LABEL.ASSOCIATED_DATASET}</span>
      <Form.Item
        name={FIELD_NAME.ASSOCIATED_DATASET}
      >
        <Select
          bordered={false}
          placeholder={'Associated Dataset'}
          showSearch={false}
          size='large'
          style={{ background: '#fff' }}
        >
          <Option
            key={null}
            value={null}
          >
              No dataset
          </Option>
          {datasets?.results.map(({ title, uuid }) => (
            <Option
              key={uuid}
              value={uuid}
            >
              {title}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </>
  )
}

AssociatedDataSet.propTypes = {
  datasets: PropTypes.object
}

const mapStateToProps = (state) => ({
  datasets: state.dataset.datasets
})

export default connect(mapStateToProps)(AssociatedDataSet)
